import React from "react";

export function LoadingIndicator({ message = "Loading...", compact = false }) {
  return (
    <div className={`loading-indicator ${compact ? "loading-indicator-compact" : ""}`} role="status" aria-live="polite">
      <div className="loading-gif" aria-hidden="true">
        <span className="loading-gif-ring"></span>
        <span className="loading-gif-dot loading-gif-dot-a"></span>
        <span className="loading-gif-dot loading-gif-dot-b"></span>
        <span className="loading-gif-dot loading-gif-dot-c"></span>
      </div>
      <div className="loading-indicator-copy">{message}</div>
    </div>
  );
}

export function LoadingScreen({ message = "Loading..." }) {
  return (
    <div className="loading-screen">
      <LoadingIndicator message={message} />
    </div>
  );
}

export function LoadingOverlay({ message = "Working..." }) {
  return (
    <div className="loading-overlay">
      <div className="loading-overlay-backdrop"></div>
      <div className="loading-overlay-card">
        <LoadingIndicator message={message} />
      </div>
    </div>
  );
}

export default LoadingIndicator;
